// 3rd Party
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

// Components
import {
  Div,
  H3,
  P,
  FlexRow,
  FlexCol,
  MarketingButton,
  VisuallyHidden,
} from 'common/styles/oc-styled-components';

import { colors } from 'common/styles/style-constants';

import {
  useWindowDimensions,
  DIMENSIONS,
} from 'providers/WindowDimensionsProvider';

import { ConfirmationSubHeading } from '../../../checkout-styled-components';

// Other
import { updateSpecificAvailabilities } from '../../../../../connect/actions';
import {
  selectSpecificAvailabilities,
  selectReason,
} from '../../../connect/selectors';
import { formatSpecificAvailabilities } from '../../../helpers/confirmation-helpers';
import { displayPreferences } from '../../../helpers/checkout-constants';

import { TimePeriodCheckboxes } from './styled-components';

// Component
const AvailabilityCard = ({ showOptionsByDefault }) => {
  const dispatch = useDispatch();

  const selectedAvailability = useSelector(selectSpecificAvailabilities);
  const selectedReasonName = useSelector(selectReason);

  const [isSelectionVisible, setIsSelectionVisible] = useState(
    !!showOptionsByDefault,
  );

  const { layout } = useWindowDimensions();

  return (
    <>
      <ConfirmationSubHeading color={colors.sageDark} aria-hidden>
        Availability Preferences
      </ConfirmationSubHeading>
      {isSelectionVisible
        ? (
          <FlexCol
            margin={`${layout === DIMENSIONS.MOBILE ? '.5em 0 0' : '15px 0 0'}`}
          >
            <H3 fontSize="18px" margin="0">
              Select your preferences
            </H3>
            <P className="sensitive-data" color="#6f6a71">
              <VisuallyHidden>Reason for visit:</VisuallyHidden>
              {selectedReasonName}
            </P>
            <FlexRow justify="space-between" margin="10px 0 0" flexWrap="wrap">
              <TimePeriodCheckboxes
                className="sensitive-data"
                onChange={e => dispatch(updateSpecificAvailabilities(e))}
                options={displayPreferences}
                defaultValue={selectedAvailability}
              />
            </FlexRow>
          </FlexCol>
        )
        : (
          <Div
            className="sensitive-data"
            margin={`${layout === DIMENSIONS.MOBILE ? '.5em 0' : '15px 0 20px'}`}
          >
            <FlexRow justify="space-between" align="flex-start">
              <Div>
                <H3
                  fontSize="18px"
                  margin={`${layout === DIMENSIONS.MOBILE ? '0' : '0 0 5px'}`}
                >
                  <VisuallyHidden>Availability:</VisuallyHidden>
                  {selectedAvailability && selectedAvailability.length > 0
                    ? formatSpecificAvailabilities(selectedAvailability)
                    : 'No Preferences'}
                </H3>
                <P color={colors.slate}>
                  <VisuallyHidden>Reason for visit:</VisuallyHidden>
                  {selectedReasonName}
                </P>
              </Div>
              <MarketingButton
                type="primary"
                size="small"
                shape="round"
                onClick={() => setIsSelectionVisible(true)}
              >
                Edit
              </MarketingButton>
            </FlexRow>
          </Div>
        )
      }
    </>
  );
};

AvailabilityCard.propTypes = {
  showOptionsByDefault: PropTypes.bool,
};

export default AvailabilityCard;
